module.exports = __webpack_public_path__ + "5f63afab2eb0ff659e1b561ec2da4b53.svg";